import { Flex } from 'antd'

import { LogoIcon, LogoText } from 'src/assets'

import { useStyles } from './styles'

export const LoadingScreen = () => {
  const { styles } = useStyles()

  return (
    <Flex justify="center" align="center" className={styles.wrapper}>
      <LogoIcon />
      <LogoText />
    </Flex>
  )
}
